import { render, staticRenderFns } from "./Inquiry_Component.vue?vue&type=template&id=38ebb595&scoped=true&"
import script from "./Inquiry_Component.vue?vue&type=script&lang=js&"
export * from "./Inquiry_Component.vue?vue&type=script&lang=js&"
import style0 from "./Inquiry_Component.vue?vue&type=style&index=0&id=38ebb595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ebb595",
  null
  
)

export default component.exports